import React from 'react';
import { ArrowDownOutlined } from '@icon';
import { IndicatorProps, OptionTypeBase } from 'react-select';

const DropdownIndicator = <OptionType extends OptionTypeBase, IsMulti extends boolean>(
  props: IndicatorProps<OptionType, IsMulti>,
) => {
  const styles = props.getStyles('dropdownIndicator', props) as React.CSSProperties;
  const {
    children = <ArrowDownOutlined width={20} height={20} color={styles.color} />,
    innerProps: { ref, ...restInnerProps },
  } = props;

  return (
    <div {...restInnerProps} ref={ref} style={styles}>
      {children}
    </div>
  );
};

export default DropdownIndicator;
